module.exports = __webpack_public_path__ + "static/media/info.9c88025d.svg";